import { render, staticRenderFns } from "./dialog-centered.vue?vue&type=template&id=fb6fb06a"
import script from "./dialog-centered.vue?vue&type=script&lang=js"
export * from "./dialog-centered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports